import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import BGMStore from './store';
import Link from '../../components/link';
import cx from 'classnames';
import BgMusicComponent from './lib';
const styles = require('./index.less');
/**
 * 使用举例:  <BGM store={store.bgmStore} className={styles.bgm} />
 *
 * @param store - 背景音乐的store
 * @param className - 背景音乐样式
 * @param style - 背景音乐传入的内置样式
 * @returns {JSX.Element}
 * @constructor
 */
const BGM = ({ store, className, style }) => {
  store.use();

  return (
    <Link className={cx(styles.root, className)}>
      {store.audioName && <div className={styles.audioName}>{store.audioName}</div>}
      {store.audioSrc && (
        <BgMusicComponent
          src={store.audioSrc}
          renderPlay={() =>
            store.musicPlayIcon ? <img className={cx(store.musicIconRotate && styles.rotate)} src={store.musicPlayIcon} alt="背景音乐图标" /> : null
          }
          renderPause={() => (store.musicPauseIcon ? <img src={store.musicPauseIcon} alt="背景音乐图标" /> : null)}
          isPlaying={store.isPlaying}
          onChange={store.handleChange}
          onClick={store.handleClick}
          style={style}
        />
      )}
    </Link>
  );
};

export default wrapStore(BGM, BGMStore);
